import {createAsyncThunk, createReducer} from '@reduxjs/toolkit';

import {ENDPOINTS} from 'constants/endpoints';
import {FrameDetailsType, OrderType} from 'desktop/pages/success/types/types';
import {apiConfig} from 'libs/api/api';

import {UpsellsResponseType} from '../upsells/upsells';

export const initialState: OrderType = {
    frames: [],
    incrementId: '',
    message: '',
    needPrescription: false,
    status: 'pending',
};

type ResponseType = UpsellsResponseType & {
    incrementId: string;
    message: string;
    needPrescription: boolean;
    frames: Array<FrameDetailsType>;
};

export const getOnePageUpsellData = createAsyncThunk<
    ResponseType,
    {
        orderId: string;
    }
>('SUCCESS_PAGE@GET_ONEPAGE_UPSELL_DATA', async ({orderId}) => {
    const response = await apiConfig.instanceGusaBackend({
        method: 'get',
        url: `${ENDPOINTS.UPSELL_GET_FROM_SUCCESS_PAGE}${orderId ? `?orderId=${orderId}` : ''}`,
    });
    return response.data;
});

/**
 * Reducer for order info on success page
 * @return {OrderType} new reducer state
 */
export const order = createReducer<OrderType>(initialState, builder => {
    builder
        .addCase(getOnePageUpsellData.fulfilled, (state, action) => {
            const {frames, incrementId, message, needPrescription} = action.payload;
            return {
                frames,
                incrementId,
                message,
                needPrescription: Boolean(needPrescription),
                status: 'fulfilled',
            };
        })
        .addCase(getOnePageUpsellData.rejected, state => ({
            ...state,
            message:
                "Your order was created, but we can't display information about it. Please contact with our Customer Service",
            status: 'rejected',
        }));
});
